<template>
  <div :class="['project-connect--card', { 'is-shortlist': isShortlist }]" v-if="project">
    <button
      v-if="isShortlist"
      class="btn btn--remove shortlist--remove"
      type="button"
      :disabled="loading"
      @click.stop="$emit('remove', project)"
    >
      <v-icon>mdi-delete-outline</v-icon>
    </button>

    <card-project
      :project="normalizedProject"
      :allow-multi-image="false"
      :show-favorite="false"
      :show-commission="true"
      :commission="project.commission"
      :use-external-link="true"
    >
      <template #after-commission>
        <button
          v-if="!isShortlist"
          class="btn btn--contact w-100"
          type="button"
          :disabled="loading"
          @click.stop="$emit('show-contact', project)"
        >
          <span>{{ loading ? 'Memuat...' : 'Pilih untuk lihat kontak' }}</span>
        </button>
        <button
          v-else
          class="btn btn--contact w-100"
          type="button"
          :disabled="!project.phone_number"
          @click.stop="$emit('open-whatsapp', project)"
        >
          <span>{{ contactLabel }}</span>
        </button>
      </template>
    </card-project>
  </div>
</template>

<script>
import CardProject from '@/components/utils/card-project.vue';

export default {
  name: 'project-connect-card',
  components: {
    CardProject,
  },
  props: {
    project: {
      default: null,
      required: true,
    },
    isShortlist: {
      default: false,
    },
    loading: {
      default: false,
    },
  },
  computed: {
    normalizedProject() {
      return {
        ...this.project,
        title: this.project.project_name || this.project.title || '-',
        property_type: this.project.property_type || this.project.project_type,
        district: this.project.area || this.project.district,
        city: this.project.city,
        subsidized: this.project.subsidized || false,
        min_bedroom: this.project.min_bedroom,
        max_bedroom: this.project.max_bedroom,
        min_bathroom: this.project.min_bathroom,
        max_bathroom: this.project.max_bathroom,
        photos: this.project.photos || [],
        developer_photo: this.project.developer_photo || this.project.developerPhoto,
        commission_disclaimer: this.project.commission_disclaimer,
        links: {
          detail: this.project.links && this.project.links.detail ? this.project.links.detail : '/',
        },
      };
    },
    hasCommission() {
      return (
        this.project.commission !== null &&
        this.project.commission !== undefined &&
        this.project.commission !== ''
      );
    },
    contactLabel() {
      const parts = [this.project.pic_name, this.project.phone_number].filter((item) => !!item);
      return parts.length > 0 ? parts.join(' - ') : 'WhatsApp PIC';
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/assets/scss/utils/variables';

.project-connect--card {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 12px;
  height: 100%;

  :deep(.card--project) {
    flex: 1;
  }
}

.btn--remove {
  width: 34px;
  min-width: 34px;
  height: 34px;
  border: 1px solid #f0d6d6;
  border-radius: 9px;
  background: $color-white;
  color: $color-beliruma-1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 6px 14px rgba(0, 0, 0, 0.12);
  padding: 0;

  .v-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    color: $color-beliruma-1;
    font-size: 20px;
    line-height: 1;
    margin: 0;
  }
}

.shortlist--remove {
  position: absolute;
  top: 14px;
  right: 14px;
  z-index: 4;
}

.btn--contact {
  background-color: #2ca24d !important;
  color: $color-white !important;
  border-radius: 999px;
  padding: 10px 16px;
  font-family: Poppins-SemiBold, sans-serif;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;

  .phone-icon {
    color: $color-white;
    margin-right: 8px;
    font-size: 18px;
  }

  &:disabled {
    opacity: 0.7;
  }
}

.is-shortlist {
  .btn--contact {
    font-family: Poppins-Bold, sans-serif;
  }
}
</style>
